import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Fda2579FormModel, AddressModel, NotificationModel, Fda2579FormModelFromJson } from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Subject } from 'rxjs';
import { BsModalService } from 'ngx-bootstrap/modal';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'pace-confirmation-fda2579-form',
    templateUrl: './confirmation-fda2579-form.component.html',
    styleUrls: ['./confirmation-fda2579-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ConfirmationFDA2579FormComponent implements AfterViewInit, OnInit, OnDestroy {
    @Input()
    public model: Fda2579FormModel;

    @Input()
    public notification: NotificationModel;
    private destroy$ = new Subject<void>();

    public fda2579FormGroup: FormGroup;
    public fda2579FormEquipmentChildren: FormArray;
    public fda2579FormAssemblerInfoChildren: FormArray;
    public fda2579FormGeneralInfoChildren: FormArray;
    public fda2579FormComponentInfoChildren: FormArray;
    public fda2579FormCommentsChildren: FormArray;
    public fda2579FormCertificationChildren: FormArray;

    public modalResult = new EventEmitter<Fda2579FormModel>();
    public readonly faTrashAlt = faTrashAlt;
    public isFDA2579Saving = false;

    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly formBuilder: FormBuilder,
        private bsModalService: BsModalService,
    ) {}

    public ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public ngOnInit(): void {
        this.fda2579FormEquipmentChildren = this.formBuilder.array([]);
        this.fda2579FormAssemblerInfoChildren = this.formBuilder.array([]);
        this.fda2579FormGeneralInfoChildren = this.formBuilder.array([]);
        this.fda2579FormComponentInfoChildren = this.formBuilder.array([]);
        this.fda2579FormCommentsChildren = this.formBuilder.array([]);
        this.fda2579FormCertificationChildren = this.formBuilder.array([]);

        this.fda2579FormGroup = this.formBuilder.group({
            fdaFormEquipmentChildren: this.fda2579FormEquipmentChildren,
            fdaFormAssemblerInfoChildren: this.fda2579FormAssemblerInfoChildren,
            fdaFormGeneralInfoChildren: this.fda2579FormGeneralInfoChildren,
            fdaFormComponentInfoChildren: this.fda2579FormComponentInfoChildren,
            fdaFormCommentsChildren: this.fda2579FormCommentsChildren,
            fdaFormCertificationChildren: this.fda2579FormCertificationChildren,
        });
    }

    public onCityChange(): void {
        this.log.debug(`ConfirmationFDA2579FormComponent: onCityChange: Change in city field, deselecting statesOfUSA`);
        AddressModel.updateStateOfUSA(this.model.notificationAddress);
    }

    public saveAndCloseFdaForm(): void {
        this.isFDA2579Saving = true;
        this.model.isFda2579FormValid = this.fda2579FormGroup.valid;

        const clonedFda2579FormModel = new Fda2579FormModelFromJson(
            JSON.parse(JSON.stringify(this.model)),
            this.notification,
        );
        this.modalResult.emit(clonedFda2579FormModel);

        this.bsModalService.hide();
        this.isFDA2579Saving = false;
    }

    public ngAfterViewInit(): void {
        // Since all the child forms for the accordions are added asynchronously, we now trigger a change detection
        // cycle asynchronously as well to update the "global" validation state
        Promise.resolve(undefined)
            .then(() => {
                this.changeDetector.detectChanges();
            })
            .catch((error) =>
                this.log.error(
                    `ConfirmationFDA2579FormComponent: ngAfterViewInit: Error while triggering change detection `,
                    JSON.stringify(error, Object.getOwnPropertyNames(error)),
                ),
            );
    }
}
